module.exports = __webpack_public_path__ + "media/images/team/deke_smith-a8880ce24d5b5b799dc3a77bd37ea83e.png";